import request from '../request'

export const mentorApi = {
  // 导师列表
  listMentor (params) {
    return request.get('/mentors', { params: params })
  },
  // 新增导师
  addMentor (data) {
    return request.post('/mentor', data)
  },
  // 删除导师
  deleteMentor (mentorId) {
    return request.delete('/mentors/' + mentorId)
  },
  getMentor (mentorId) {
    return request.get('/mentors/' + mentorId)
  },
  // 修改导师信息
  updateMentor (id, data) {
    return request.put('/mentors/' + id, data)
  },
}

export default mentorApi
